import React from 'react'
import { withRouter } from 'react-router-dom'
import { SuccessCheckmarkIcon } from '@pga/pga-component-library'
import { Container, Row, Col } from 'reactstrap'
import { StyledLink } from '../shared.styles'
import { PGATLD } from '../../helpers/constants'
import qs from 'query-string'

const messages = {
  payment: {
    title: 'Thank you for making a payment!',
    body: 'Your payment was successfully processed. A receipt has been sent to your email.',
    link: 'Go To Dashboard',
    href: `https://${PGATLD}`
  },
  achPayment: {
    title: 'Thank you for making a payment!',
    body: 'Your ACH payment was successfully submitted and is currently being processed. This can take 4-5 business days. A receipt will be sent to your email upon completion.',
    link: 'Go To Dashboard',
    href: `https://${PGATLD}`
  },
  'proxy-request': {
    title: 'Proxy request sent!',
    body: 'An email has been sent to your proxy with further instructions.',
    link: 'Make a payment',
    href: '/',
    secondaryLink: 'Return to PGA.org',
    secondaryHref: `https://${PGATLD}`
  },
  contributions: {
    title: 'Thank you for your contribution!',
    body: 'Your payment was successfully processed. A receipt has been sent to your email.',
    link: 'Make another contribution',
    href: '/contributions',
    secondaryLink: 'Return to PGA.org',
    secondaryHref: `https://${PGATLD}/pga-medical-and-disaster-relief-fund`
  },
  achContributions: {
    title: 'Thank you for your contribution!',
    body: 'Your ACH payment was successfully submitted and is currently being processed. This can take 4-5 business days. A receipt will be sent to your email upon completion.',
    link: 'Make another contribution',
    href: '/contributions',
    secondaryLink: 'Return to PGA.org',
    secondaryHref: `https://${PGATLD}/pga-medical-and-disaster-relief-fund`
  }
}

const Success = ({ location: { search } }) => {
  const { type } = qs.parse(search)
  const message = messages[type] ? messages[type] : messages.payment
  return (
    <Container className='mt-5 text-center'>
      <Row className='mb-5'>
        <Col>
          <SuccessCheckmarkIcon size={80} />
          <h1>{message.title}</h1>
          {message.body
            ? <p>{message.body}</p>
            : null}
        </Col>
      </Row>
      <Row>
        <Col className='mb-5' lg={{ size: 4, offset: 4 }}>
          <StyledLink href={message.href}>
            {message.link}
          </StyledLink>
        </Col>
      </Row>
      <Row>
        <Col lg={{ padding: 10, size: 4, offset: 4 }}>
          <a href={message.secondaryHref} target='_blank' rel='noopener noreferrer'>
            {message.secondaryLink}
          </a>
        </Col>
      </Row>
    </Container>
  )
}

export default withRouter(Success)
